// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__top-bar',
    // #endregion
    // #region Computed
    computed: {
        hasUser() {
            return this.$host.store.get("session").isAuthenticated;
        },
        currentUser() {
            return this.$host.store.get("session").currentUser;
        },
        userInitials() {
            if (!this.currentUser) {
                return '';
            }
            return this.currentUser.initials;
        },
        userDisplayName() {
            if (!this.currentUser) {
                return '';
            }
            return this.currentUser.displayName;
        },
    }
    // #endregion
});
// #endregion
